import Icon from 'components/Icon';
import Pill from 'components/Widget/Pill';
import { DsSection } from 'designSystem/types';
import { DS_SECTION_CHROME, DS_TAB_CHROME, sectionToTabTarget } from 'designSystem/util';
import { pathsToDsLinks } from 'designSystem/content/util';
import useDsNavigation from 'hooks/useDsNavigation';
import * as S from './styles';

interface DsUpdateCardProps {
	section: DsSection;
	paths?: string[];
	isMobile?: boolean;
}

const DsUpdateCard = ({ section, paths = [], isMobile }: DsUpdateCardProps) => {
	const { openTab } = useDsNavigation();
	const sectionChrome = DS_SECTION_CHROME[section];

	// pathsToDsLinks normalizes paths per section (theme: stem→category key,
	// components: dedup by subdir, others: verbatim) and marks deletions.
	const links = pathsToDsLinks(paths, section);

	// One pill per distinct tab kind resolved from non-deleted links.
	const tabKinds = [
		...new Set(
			links
				.filter((l) => !l.deleted && l.contentPath != null)
				.map((l) => sectionToTabTarget(section, l.contentPath).kind),
		),
	];

	const title =
		tabKinds.length === 1
			? `${DS_TAB_CHROME[tabKinds[0]].label} Updated`
			: 'Design System Updated';
	const headerIcon =
		tabKinds.length === 1
			? DS_TAB_CHROME[tabKinds[0]].icon
			: sectionChrome.icon;

	return (
		<S.UpdateCard isMobile={isMobile}>
			<S.UpdateTitleRow>
				<S.UpdateIcon>
					<Icon type={headerIcon} width={16} height={16} />
				</S.UpdateIcon>
				<S.UpdateTitle>{title}</S.UpdateTitle>
			</S.UpdateTitleRow>
			<S.ItemList>
				{tabKinds.length > 0
					? tabKinds.map((kind) => (
							<Pill
								key={kind}
								label={DS_TAB_CHROME[kind].label}
								tooltip="Click to open in design system"
								onClick={(e) => {
									e.stopPropagation();
									openTab(kind);
								}}
							/>
						))
					: (
						<Pill
							label={sectionChrome.label}
							tooltip="Click to open in design system"
							onClick={(e) => {
								e.stopPropagation();
								openTab(sectionToTabTarget(section, undefined).kind);
							}}
						/>
					)
				}
			</S.ItemList>
		</S.UpdateCard>
	);
};

export default DsUpdateCard;
